// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--2c8S8","themeDark":"index-module--themeDark--22nJz"};